const years = Array.from(new Array(75), (val, index) =>
  Math.abs(index - new Date().getFullYear())
);

export default years;
